import { createContext, useContext } from 'react';
export var ColorPickerContext = /*#__PURE__*/createContext({});
export var useColorPickerContext = function () {
  return useContext(ColorPickerContext);
};